'use strict';

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var table = require('./base-table.json'); // map for code -> print friendly name


var tableByCode = {};

for (var _i = 0, _Object$entries = Object.entries(table); _i < _Object$entries.length; _i++) {
  var _ref3 = _Object$entries[_i];

  var _ref2 = _slicedToArray(_ref3, 2);

  var name = _ref2[0];
  var code = _ref2[1];
  if (tableByCode[code] === undefined) tableByCode[code] = name;
}

module.exports = Object.freeze(tableByCode);